import React from 'react';
import './calories.css';

// The house input class string, copied from the Item drawer so this field is
// indistinguishable from Name and Price beside it.
const DEFAULT_INPUT_CLASS =
  'block w-full appearance-none rounded-md border dark:text-slate-200 dark:bg-slate-800 border-gray-300 px-3 py-2 placeholder-black placeholder-opacity-25 focus:border-blue-500 focus:outline-none focus:ring-blue-500 sm:text-sm dark:focus:border-sky-400 dark:focus:ring-sky-400 dark:placeholder:text-white dark:border-slate-500';

// Emits the raw string from `e.target.value`, exactly like the price inputs it
// sits next to. Wire types are enforced once, in the api services — a controlled
// type="number" that reparsed on every keystroke would fight the user over a
// lone "-" or a trailing decimal point.
//
// A main option's calories cannot be negative, so a leading minus sign is
// dropped unless the caller opts in (a modifier delta of -80 is the whole point
// of "No Sauce"). Drop the sign positionally, never by rewriting the string:
// type="number" accepts scientific notation, so `.replace('-', '')` over "1e-5"
// deletes the *exponent's* sign and yields "1e5" — 100000 cal.
const stripLeadingSign = (raw, allowNegative) =>
  allowNegative || !raw.startsWith('-') ? raw : raw.slice(1);

const CaloriesInput = ({
  value,
  onChange,
  id = 'calories',
  allowNegative = false,
  placeholder = '0',
  inputClassName = DEFAULT_INPUT_CLASS,
}) => (
  <div className="relative rounded-md shadow-sm">
    <input
      id={id}
      name="calories"
      type="number"
      step={1}
      min={allowNegative ? undefined : 0}
      value={value ?? ''}
      onChange={(e) => onChange(stripLeadingSign(e.target.value, allowNegative))}
      placeholder={placeholder}
      className={`calories-input ${inputClassName} !pr-10`}
    />
    <span className="pointer-events-none absolute inset-y-0 right-0 flex items-center pr-3 text-xs text-gray-400 dark:text-slate-400">
      cal
    </span>
  </div>
);

export default CaloriesInput;
